import { useKeyPress } from '../../Shared/UseKeyPress';
import { AnnotationsForGrid } from '../Annotation/annotation.types';

function useDeleteAnnotation(
  selectedAnnotationId: any,
  presentAnnotations: AnnotationsForGrid[] | null,
  havePermissionToUse: boolean,
  onSetAnnotationIdsForDelete: (ids: string[]) => void,
  onShowDeleteDialog: () => void
) {
  let canBeDeleted: boolean = false;

  if (selectedAnnotationId) {
    const finding = presentAnnotations?.find(x => x.id === selectedAnnotationId);

    if (finding) {
      canBeDeleted = finding.canBeDeleted;
    }
  }

  const deleteAnnotation = () => {
    if (selectedAnnotationId && canBeDeleted) {
      onSetAnnotationIdsForDelete([selectedAnnotationId]);
      onShowDeleteDialog();
    }
  };

  useKeyPress('Delete', false, () => deleteAnnotation());
}
export default useDeleteAnnotation;
